import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/v1/admin/auth/login',
    method: 'post',
    mock: false,
    data,
  })
}

// get /merchant/user/info
export function getMerchantInfo() {
  return request({
    url: '/merchant/user/info',
    method: 'get',
    skipConfirm: true,
  })
}

// get /admin/user/info
export function getAdminInfo() {
  return request({
    url: '/api/v1/admin/auth/verify_session',
    method: 'post',
    mock: false,
    skipConfirm: true,
  })
}

export function getInfo(token) {
  /* return request({
    url: '/vue-element-admin/user/info',
    method: 'get',
    params: { token }
  }) */
}

export function logout() {
  /* return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  }) */
}

// 获取账变记录
export function getAccountChange(params) {
  return request({
    url: '/api/v1/admin/members/member_list/gold_change_logs',
    method: 'post',
    mock: false,
    data: params,
  })
}

// 调整账户调整列表
export function setAccountAdjust(params) {
  return request({
    url: '/api/v1/admin/members/member_list/change_player_gold',
    method: 'post',
    mock: false,
    data: params,
  })
}
